<template>
  <button
    @click="zobrazMojiPolohu"
    title="Zobrazit moji polohu"
    class="moje-poloha-button"
  >
    📍 Načti moji polohu
  </button>
</template>

<script setup>
import { inject } from "vue";
import L from "leaflet";
import { LadzoConsole as Lc } from "../../js/global/ladzo-console.js";

const map = inject("map");
const zavriSidebar = inject("Sidebar.zavri");

function zobrazMojiPolohu() {
  if (!navigator.geolocation) {
    alert("Prohlížeč nepodporuje geolokaci.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const lat = pos.coords.latitude;
      const lon = pos.coords.longitude;

      if (!map?.value) {
        Lc.err("Mapa není připravena.");
        return;
      }

      map.value.setView([lat, lon], 15);
      //L.marker([lat, lon]).addTo(map.value).bindPopup("Tady jsi!").openPopup();

      const customIcon = L.icon({
        iconUrl: "/img/leaflet/marker-icon-orange.png",
        iconRetinaUrl: "/img/leaflet/marker-icon-orange.png",
        shadowUrl: "/img/leaflet/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      L.marker([lat, lon], { icon: customIcon })
        .addTo(map.value)
        .bindPopup("Tady jsi!")
        .openPopup();

      zavriSidebar();
    },
    (err) => {
      alert("Nelze získat polohu.");
      console.error(err);
    }
  );
}
</script>

<style scoped>
.moje-poloha-button {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
}
</style>
